/* eslint-disable import/prefer-default-export */
export const formwerkRef = 'formwerk'
